import * as fetchCreators from './fetchCreators';
import {CONFIGURATION} from '../constants/config';

const locationApiUrl = CONFIGURATION.SERVER_API_URL + "/location/";

export function GetStates() {
  return fetchCreators.get(locationApiUrl);
}
